import { Editor } from '@tiptap/core'
import { NodeType } from '@tiptap/pm/model'
import { Plugin, PluginKey } from '@tiptap/pm/state'
import { find, test } from 'linkifyjs'

type PasteHandlerOptions = {
  editor: Editor
  type: NodeType
  name: string
}

export function pasteHandler(options: PasteHandlerOptions): Plugin {
  return new Plugin({
    key: new PluginKey('handleEmbedLinkPaste'),
    props: {
      transformPastedText(text, _plain, _view) {
        let returnedText: string = text
        const isPastedTextLink = test(returnedText)

        // Some links will contain an ending "/", which triggers the Contextual Menu.
        // This removes that & pastes the link without.
        if (isPastedTextLink && returnedText.endsWith('/')) {
          returnedText = text.slice(0, -1)
        }

        return returnedText
      },
      handlePaste: (view, _event, slice) => {
        const { state } = view
        const { selection } = state
        const { empty } = selection

        if (!empty) {
          return false
        }

        let textContent = ''

        slice.content.forEach((node) => {
          textContent += node.textContent
        })

        const link = find(textContent).find(
          (item) => item.isLink && item.value === textContent
        )

        if (!textContent || !link) {
          return false
        }

        options.editor.commands.setNode(options.type, {
          url: link.href,
          src: "", // Image src
          title: "", // Image title
        })
      },
    },
  })
}
